(ns pfo.chat.debug
  (:require
   [ajax.core]
   [ajax.formats :refer [text-response-format]]
   ["highlight.js/lib/core" :as hljs]
   ["highlight.js/lib/languages/json" :as json]
   [pfo.util :as util]
   [pfo.tz :as tz]
   [pfo.common.component :as common-component]))

(.registerLanguage hljs "json" json)

(defn pretty-json [x]
  (cond
    ;; nil → render empty string
    (nil? x) ""

    ;; JS object / CLJS map → stringify
    (and (object? x) (not (string? x)))
    (js/JSON.stringify x nil 2)

    ;; string → try to parse, otherwise leave as-is
    (string? x)
    (try
      (js/JSON.stringify (js/JSON.parse x) nil 2)
      (catch :default _
        x))

    ;; fallback → stringify anything else
    :else
    (str x)))

(defn code-block [{:keys [code lang]}]
  [:div.llm-code [:pre
   [:code {:class (str "language-" lang)
           :ref #(when %
                   (.highlightElement hljs %))}
    code]]])

(defn json-block [code]
  [code-block {:lang "json" :code (pretty-json code)}])


(defn block-text [block]
  [:div {:on-click (util/handler
                     (fn []
                       (common-component/show-modal :chat-debug-details
                         [:div [json-block (:text block)]]
                         nil)))
         :style {:max-height :10em
                 :cursor :pointer
                 :overflow :hidden}}
   [json-block (:text block)]])

(defn block-tool [block]
  [:div.llm-code
   [:pre (:tool_name block)]
   [json-block (:tool_input block)]])

(defn error-cell
  "Renders the error column. Keys on whether any error detail is populated, not on
  llm_has_error: that flag decides whether the message is excluded from LLM history,
  and a failure that leaves the history valid records its detail with the flag off."
  [err]
  (let [code    (:llm_error_http_code err)
        message (:llm_error_message err)
        raw     (:llm_raw_error_message err)
        etype   (:llm_error_type err)]
    ;; The flag alone is a state worth showing: recovery raises it on every
    ;; message of a dropped turn-fragment but writes detail onto the first one
    ;; only, so the rest carry exclusion and nothing else.
    (if-not (or (:llm_has_error err) (and code (pos? code)) (seq message) (seq raw) (seq etype))
      "no"
      [:div
       [:p (if (:llm_has_error err)
             "excluded from history"
             "recorded, still in history")]
       (when (and code (pos? code)) [:p "HTTP code: " code])
       (when (seq etype) [:p "Type: " etype])
       (when (seq message) [:p message])
       (when (seq raw) [json-block raw])])))

(defn conversation-table [conversation]
  [:table.t-table-redesign
   [:thead
    [:tr
     [:th {:rowspan 2} "Time"]
     [:th {:rowspan 2} "Who"]
     [:th {:rowspan 2} "Tokens I/O"]
     [:th {:rowspan 2} "Error?"]
     [:th {:colspan 3} "Blocks"]]
    [:tr
     [:th "Type"]
     [:th "Tool"]
     [:th "Text"]]]
   [:tbody
    (doall
      (mapcat
        (fn [message]
          (let [blocks (:blocks message)
                blocks (or (seq blocks) [{}])
                num-blocks (count blocks)
                first-block (first blocks)
                rest-blocks (rest blocks)]
            (cons
              [:tr
               [:td {:rowspan num-blocks} (-> (:created_at message) (util/parse-datetime) (tz/to-browser-time) (util/date-format-date-hour-minute))]
               [:td {:rowspan num-blocks} (:role message)]
               [:td {:rowspan num-blocks} (:input_tokens message) " / " (:output_tokens message)]
               [:td {:rowspan num-blocks} [error-cell (:llm_error message)]]
               [:td (:type first-block)]
               [:td [block-tool first-block]]
               [:td (block-text first-block)]]
              (doall
                (for [block rest-blocks]
                  [:tr
                   [:td (:type block)]
                   [:td [block-tool block]]
                   [:td
                    (block-text block)]])))))
        (sort-by
          (fn [msg] [(not= (:role msg) "system") (:sequence msg)])
          (:messages conversation))))]])

(defn dump-download
  "Download link for the debug dump at URL."
  [url]
  [common-component/download-button {:ajax-url url
                                     :ajax-options {:params {:download "1"}
                                                    :response-format (ajax.core/ring-response-format {:format (text-response-format)})}
                                     :component :a} "Download"])

(defn conversation-dumps
  "The main conversation and its side conversations of a debug dump."
  [conversations]
  [:div
   (doall
     (map-indexed
       (fn [idx conv]
         [:div.u-margin-top {:key (:id conv)}
          [:h3.u-padding-top
           (if (zero? idx) "Main conversation" "Side conversation")
           " "
           [:small "#" (:id conv)]]
          [conversation-table conv]])
       conversations))])
